/* ========================================================================
   Cookie popup
 ========================================================================== */

let ccConfig = null;
let ccContainer = null;

app.cookiePopup = (function () {
  'use strict';

  function initConfig() {
    ccConfig = {
      showConsoleLog: true,
      enableDataLayerEvents: true,
      position: 'bottom-left',
      theme: 'dark',
      cookie: {
        name: 'cookieconsent_status_v3',
      },
      content: {
        infoLinkHref: ccContainer.dataset.infoLinkHref,
        infoLinkTarget: '_self',
      },
      // blacklistPage: ['/cookieverklaring/'],

      onInitialise: function (state, status) {},
      onStatusChange: function (state, status, chosenBefore) {
        // DATALAYER
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'cookieConsent',
          consent: state.grantedCategories.join(),
        });
      },
      onPopupOpen: function (state, status) {},
      onPopupClose: function (state) {},
    };
  }

  function loadPopupScript() {
    let js = document.createElement('script');
    js.id = 'ccPopupScript';
    js.defer = 'true';
    js.src = ccContainer.dataset.src;

    ccContainer.after(js);
    ccContainer.remove();
  }

  function open() {
    if (typeof ccPopup !== 'undefined') {
      ccPopup.open();
    }
  }

  function init() {
    ccContainer = document.getElementById('ccPopup');

    if (!ccContainer) {
      console.log('Cookie popup: container is missing!');
      return;
    }

    initConfig();
    loadPopupScript();
  }

  // Expose public functions and variables
  return {
    init: init,
    open: open,
  };
})();
